import type { URL } from '../@shared/interfaces/value-objects.interface'

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

export type HttpHeader = Record<string, string>

interface HttpErrorInterface {
  status: number
  response: any
}

export class HttpError extends Error {
  constructor (error: HttpErrorInterface) {
    super(JSON.stringify(error))
    this.name = 'HttpErrorRequest'
  }

  parse (): HttpError {
    return JSON.parse(this.message)
  }
}

export interface HttpAdapter {
  useDefaultHeaders: boolean
  setHeaders: (headers: HttpHeader) => void
  getDefaultHeaders: () => HttpHeader
  request: <Response, Payload = {}>(method: HttpMethod, url: URL, payload?: Payload) => Promise<Response>
}
